import Controller from '@ember/controller';

export default class PropertyDevicesPrintersConnectionsIndexController extends Controller {
  queryParams = ['lastPrinterConnectionId'];
}
